module.exports = __webpack_public_path__ + "media/images/every-word-bg-fade-1500w-a70c1199076de090b5098a4602fda66b.jpg";